/**
 * 检测颜色是否为浅色
 *
 * @param r - rgb 模式的红色向量值
 * @param g - rgb 模式的绿色向量值
 * @param b - rgb 模式的蓝色向量值
 * @param alpha - 透明度
 *
 * @see https://www.w3.org/WAI/ER/WD-AERT/#color-contrast
 */
function isLightColor({ r, g, b, alpha = 1, }) {
    const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    return yiq >= 125 || alpha < 0.5;
}
/**
 * @param color - rgb 模式的颜色
 */
function parseRgb(color) {
    const match = /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/.exec(color);
    if (!match) {
        return null;
    }
    return {
        r: Number(match[1]),
        g: Number(match[2]),
        b: Number(match[3]),
        alpha: Number(match[4]),
    };
}
/**
 * 将 16 进制颜色值转换为 rgb 模式的颜色值
 * @param hex - 颜色值
 */
function hexToRgb(hex) {
    if (hex === 'transparent') {
        return {
            r: 0, g: 0, b: 0, alpha: 0,
        };
    }
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{0,2})$/i.exec(hex);
    if (!result) {
        return null;
    }
    const color = {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
    };
    if (result[4]) {
        color.alpha = parseInt(result[4], 16) / 255;
    }
    return color;
}

export { hexToRgb, isLightColor, parseRgb };
//# sourceMappingURL=color-utils.js.map
